import React, { createContext, useContext, useState, useEffect } from "react";

const DealerAuthContext = createContext();

export function DealerAuthProvider({ children }) {
  const [dealer, setDealer] = useState(null);
  const [loading, setLoading] = useState(true);

 const API = process.env.REACT_APP_API_URL ? (process.env.REACT_APP_API_URL + '/api/v1') : '/api/v1';


  // ✅ Load dealer from localStorage on refresh
  useEffect(() => {
    const token = localStorage.getItem("dealerToken");
    const user = localStorage.getItem("dealerUser");

    if (token && user) {
      try {
        const parsed = JSON.parse(user);
        if (parsed.role === "dealer") {
          setDealer(parsed);
        }
      } catch (e) {
        console.error("Invalid dealer data");
      }
    }

    setLoading(false);
  }, []);

  // ✅ EMAIL LOGIN (already existing)
  const login = async (email, password) => {
    const res = await fetch(`${API}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();

    if (!res.ok) throw new Error(data.error || "Login failed");

    if (data.user.role !== "dealer") {
      throw new Error("Not a dealer account");
    }

    localStorage.setItem("dealerToken", data.token);
    localStorage.setItem("dealerUser", JSON.stringify(data.user));
    localStorage.setItem("authToken", data.token);

    setDealer(data.user);

    return data.user;
  };

  // ✅ ⭐ FIX: PHONE OTP LOGIN (MOST IMPORTANT)
  const loginWithPhone = async (phone, otp) => {
    const res = await fetch(`${API}/dealer_phone_auth/verify_otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ phone, otp }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "OTP verification failed");
    }

    // ✅ SAVE TOKEN + USER
    localStorage.setItem("dealerToken", data.token);
    localStorage.setItem("dealerUser", JSON.stringify(data.user));
    localStorage.setItem("authToken", data.token);

    // ✅ IMPORTANT: set state
    setDealer(data.user);

    return data.user;
  };

  // ✅ LOGOUT
  const logout = () => {
    localStorage.removeItem("dealerToken");
    localStorage.removeItem("dealerUser");
    localStorage.removeItem("authToken");
    setDealer(null);
  };

  return (
    <DealerAuthContext.Provider
      value={{
        dealer,
        loading,
        login,
        loginWithPhone, // ⭐ IMPORTANT ADD
        logout,
      }}
    >
      {children}
    </DealerAuthContext.Provider>
  );
}

export const useDealerAuth = () => useContext(DealerAuthContext);